(function () {
    class ToggleNotificationsModalComponent {
        constructor(
            $scope,
            $uibModalInstance,
            name,
            enabled
        ) {
            this.$scope = $scope;
            this.$uibModalInstance = $uibModalInstance;
            this.$scope.name = name;
            this.$scope.enabled = enabled;
            this.$scope.cancelToggle = () => {
                this.$uibModalInstance.close();
            };
            this.$scope.continueToggle = () => {
                this.$uibModalInstance.close(true);
            };
        }
    }

    angular
        .module("dashboard")
        .controller(
            "ToggleNotificationsModalController",
            [
                "$scope",
                "$uibModalInstance",
                "name",
                "enabled",
                ToggleNotificationsModalComponent
            ]
        );
})();
